import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Cómo voy a recibir el material?',
    answer: 'Inmediatamente después del pago, vas a recibir un email con acceso a toda la plataforma donde están las guías, bonos y la comunidad. Podés acceder desde tu celular, tablet o computadora.'
  }, {
    question: '¿El contenido es solo para mujeres?',
    answer: 'El contenido está diseñado principalmente para mujeres, pero cualquier persona que quiera mejorar sus técnicas orales puede aprovecharlo al máximo. Las técnicas son universales.'
  }, {
    question: '¿Cuánto tiempo tengo acceso?',
    answer: 'El acceso es de por vida. Una vez que comprás, el contenido es tuyo para siempre, incluyendo todas las futuras actualizaciones que hagamos al material sin costo extra.'
  }, {
    question: '¿Es seguro el pago?',
    answer: 'Sí, utilizamos plataformas de pago 100% seguras y encriptadas. Tu información financiera está protegida y nosotros no tenemos acceso a los datos de tu tarjeta.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tenés 7 días de garantía incondicional. Si entrás, ves el material y sentís que no es para vos o no estás satisfecha, nos mandás un email y te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-[#1A0230] relative px-4 sm:px-6 lg:px-8" data-id="element-62">
      <div className="max-w-3xl mx-auto" data-id="element-63">
        <div className="text-center mb-16" data-id="element-64">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4" data-id="element-65">
            Preguntas <span className="text-[#FF2D8A]" data-id="element-66">Frecuentes</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-67">
            Resolvemos todas tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="space-y-4" data-id="element-68">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden backdrop-blur-sm" data-id="element-69">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-70">
                <span className="text-lg font-bold text-white pr-8" data-id="element-71">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#FF2D8A] transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-72" />
              </button>

              <AnimatePresence data-id="element-73">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-74">
                    <div className="px-6 pb-5 text-gray-300 leading-relaxed border-t border-white/5 pt-4" data-id="element-75">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}